module.exports = "a7e8fb68aeeb1311eb5f980c714b281f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/cut.png
// module id = 15
// module chunks = 0